<template>
  <div class="final-filters">
    <div :class="[{noPaddingBottomHeader: this.openFinalFilters}, 'header-final-filter']" v-on:click="handleOpenFinalFilters">
      <h4>Ver resumo</h4>
      <button>
        <ChevronDownIcon class="chevron" :class="{openFinalFilters: this.openFinalFilters}"/>
      </button>
    </div>
    <div class="body-final-filters" :class="{openFinalFilters: this.openFinalFilters}">
      <div class="line-filters">
        <div class="filter small-line-in-desktop">
          <div class="title-filter">
            <p>Ambiente</p>
          </div>
          <DropdownFinalFilters 
            :keyDropdown="'rooms'" 
            :roomSelected="this.finalFilterUserChoices.roomSelected"
            @changeFinalFilters="changeDropdownFinalFilters"
            @handleOpenDropdown="handleOpenDropdown"
            :open="openDropdown"
          />
        </div>

        <div class="filter filter-preferences">
          <div class="title-filter largest-title-filter">
            <p>Preferências</p>
          </div>
          <div class="preferences">
            <DropdownFinalFilters 
              :keyDropdown="'passions'" 
              :passionSelected="this.finalFilterUserChoices.passionSelected"
              @changeFinalFilters="changeDropdownFinalFilters"
              @handleOpenDropdown="handleOpenDropdown"
              :open="openDropdown"
            />
            <DropdownFinalFilters 
              :keyDropdown="'features'" 
              :passionSelected="this.finalFilterUserChoices.passionSelected"
              :featureSelected="this.finalFilterUserChoices.featureSelected"
              :featuresByPassion="featuresByPassion"
              @changeFinalFilters="changeDropdownFinalFilters"
              @handleOpenDropdown="handleOpenDropdown"
              :open="openDropdown"
            />
          </div>
        </div>
      </div>

      <div class="line-filters">
        <div class="filter">
          <div class="title-filter">
            <p>Tamanho</p>
          </div>
          <RangeSliderMarks 
            @selectInchFinalFilter="onSelectInchFinalFilter" 
            :userChoices="finalFilterUserChoices" 
            :sizesfinalFilter="sizes"
            :finalFilter="true" 
            :allowsIteration="!!this.finalFilterUserChoices.featureSelected"
            :openFinalFilters="openFinalFilters"
          />
        </div>

        <div class="filter price-filter">
          <div class="title-filter">
            <p>Preço</p>
          </div>
          <RangeSlider 
            :min="minPrice" 
            :max="maxPrice" 
            @selectPriceFinalFilter="onSelectPriceFinalFilter" 
            :finalFilter="true" 
            :openFinalFilters="openFinalFilters"
          />
        </div>
      </div>

      <div class="button-area">
        <button class="button primary" v-on:click="onClickFilter">Filtrar</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import ChevronDownIcon from '../../assets/chevron-down.svg'

import DropdownFinalFilters from './DropdownFinalFilters.vue';
import RangeSliderMarks from '../RangeSliderMarks.vue';
import RangeSlider from '../RangeSlider.vue';

import passions from '../../constants/passions';

import { getFeaturesByPassion, getSizes, getProducts } from '../../utils/dataHandler';

export default {
  name: "FinalFilters",
  components: {
    ChevronDownIcon,
    DropdownFinalFilters,
    RangeSliderMarks,
    RangeSlider
  },
  watch: {},
  props: ["sendAnalytics", "userChoices", "openFinalFilters"],
  data() {
    return {
      minPrice: parseInt(sessionStorage.getItem('min')),
      maxPrice: parseInt(sessionStorage.getItem('max')),
      finalFilterUserChoices: {
        ...this.userChoices,

        priceSelected: {
          minPrice: parseInt(sessionStorage.getItem('min')),
          maxPrice: parseInt(sessionStorage.getItem('max')),
        },
      },
      featuresByPassion: this.userChoices.passionSelected === 'todos' ? [] : getFeaturesByPassion(this.userChoices.passionSelected).featuresByPassion,
      sizes: getSizes({
        passion: this.userChoices.passionSelected,
        feature: this.userChoices.featureSelected
      }),
      openDropdown: '',
    };
  },
  computed: {},
  methods: {
    onSelectInchFinalFilter(inch) {
      this.finalFilterUserChoices.inchSelected = inch;

      const { price } = getProducts({
        passion: this.finalFilterUserChoices.passionSelected,
        feature:  this.finalFilterUserChoices.featureSelected,
        size: inch
      });
      
      this.minPrice = price.min;
      this.maxPrice = price.max;
     
      this.finalFilterUserChoices.priceSelected = {
        minPrice: price.min,
        maxPrice: price.max,
      };
      

      // Samsung Analytics
      window.click_s_evar_event('o', '26', 'resumo', 'click', 'preferencias-tamanho-' + inch[0] + '-' + inch[1]);

    },

    onSelectPriceFinalFilter(selectPrice) {
      Object.assign(this.finalFilterUserChoices.priceSelected, {
        maxPrice: selectPrice
      });

      // Samsung Analytics
      window.click_s_evar_event('o', '26', 'resumo', 'click', 'preferencias-preco-' + this.minPrice + '-' + selectPrice);
    },

    changeDropdownFinalFilters({option, key}){
     
      let newRangePrice;

      switch(key){
        case "rooms": 
          this.finalFilterUserChoices.roomSelected = option;
          
          // Samsung Analytics
          window.click_s_evar_event('o', '26', 'resumo', 'click', 'ambiente-' + option.adobeAnalytics);
        break;

        case "passions":
          this.finalFilterUserChoices.passionSelected = option.title;
          this.finalFilterUserChoices.featureSelected = "";
          this.featuresByPassion = getFeaturesByPassion(option.title).featuresByPassion;

          if(option.title === 'todos'){
            this.sizes = getSizes({
              passion: option.title,
            });

            if(this.sizes.length > 1 && this.sizes[0] !== this.sizes[this.sizes.length - 1]){
              this.finalFilterUserChoices.inchSelected = [
                `${this.sizes[0]}”`,
                `${this.sizes[this.sizes.length - 1]}”`
              ];
            }else{
              delete this.finalFilterUserChoices.inchSelected;
            }
          }

          newRangePrice = getProducts({passion: option.title});
          
          this.minPrice = newRangePrice.price.min;
          this.maxPrice = newRangePrice.price.max;
          
          this.finalFilterUserChoices.priceSelected = {
            minPrice: newRangePrice.price.min,
            maxPrice: newRangePrice.price.max,
          };

          // Samsung Analytics
          window.click_s_evar_event('o', '26', 'resumo', 'click', 'preferências-atividades-' + option.adobeAnalyticsPassions);

        break;

        case "features":
          this.finalFilterUserChoices.featureSelected = option.name;
          this.sizes = getSizes({
            passion: this.finalFilterUserChoices.passionSelected,
            feature: option.name,
          });

          newRangePrice = getProducts({
            passion: this.finalFilterUserChoices.passionSelected,
            feature: option.name,
          });
         
          this.minPrice = newRangePrice.price.min;
          this.maxPrice = newRangePrice.price.max;
          
          if(newRangePrice.price.min !== newRangePrice.price.max){
            
            this.finalFilterUserChoices.priceSelected = {
              minPrice: newRangePrice.price.min,
              maxPrice: newRangePrice.price.max,
            };
          }

          if(this.sizes.length > 1 && this.sizes[0] !== this.sizes[this.sizes.length - 1]){
            
            this.finalFilterUserChoices.inchSelected = [
              `${this.sizes[0]}”`,
              `${this.sizes[this.sizes.length - 1]}”`
            ];
          }else if(this.sizes.length == 1){
            this.finalFilterUserChoices.inchSelected = [
              `${this.sizes[0]}”`,
              `${this.sizes[0]}”`
            ];
          }else{
            delete this.finalFilterUserChoices.inchSelected;
          }

          // Samsung Analytics
          window.click_s_evar_event('o', '26', 'resumo', 'click', 'preferências-funcionalidades-' + option.adobeAnalyticsFeatures);

        break;
      }
      this.openDropdown = '';
    },
    onClickFilter(){
      
      if(this.finalFilterUserChoices.passionSelected !== "todos"){
        if(this.finalFilterUserChoices.featureSelected == "") {
          Vue.$toast.open({
            message: 'Selecione uma funcionalidade para prosseguir',
            type: 'error',
            position: 'bottom-right',
            pauseOnHover:true
          });
          return;
        }
      }
      
          
         
      // Samsung Analytics
      window.click_s_evar_event('o', '26', 'resumo', 'click', 'filtrar');

      // Môre Analytics
      let roomOld = this.userChoices.roomSelected;

      let roomNew = this.finalFilterUserChoices.roomSelected;

      let [passionOld] = passions.filter((passion) => this.userChoices.passionSelected === passion.title);

      let [passionNew] = passions.filter((passion) => this.finalFilterUserChoices.passionSelected === passion.title);

      let [featureOld] = passionOld.featuresByPassion.filter((feature) => this.userChoices.featureSelected === feature.name);      

      let [featureNew] = passionNew.featuresByPassion.filter((feature) => this.finalFilterUserChoices.featureSelected === feature.name);

      let inchOld = this.userChoices.inchSelected[0] + '-' + this.userChoices.inchSelected[1];
      
      let inchNew = this.finalFilterUserChoices.inchSelected[0] + '-' + this.finalFilterUserChoices.inchSelected[1];

      let priceOld = this.userChoices.priceSelected.min + '-' + this.userChoices.priceSelected.max;

      let priceNew = this.finalFilterUserChoices.priceSelected.minPrice + '-' + this.finalFilterUserChoices.priceSelected.maxPrice;

   
      if (passionOld.title === "todos"){
        featureOld = {};
        featureOld.adobeAnalyticsFeatures = "todas"
      }

      if (passionNew.title === "todos"){
        featureNew = {};
        featureNew.adobeAnalyticsFeatures = "todas"
      }

      window.dataLayer.push({
          event: `gtm.resumo`,
          target: "gtm-more",
          action: "navigation",
          ambiente_anterior: `${roomOld.name}`,
          ambiente_atual: `${roomNew.name}`,
          atividade_anterior: `${passionOld.adobeAnalyticsPassions}`,
          atividade_atual: `${passionNew.adobeAnalyticsPassions}`,
          feature_anterior: `${featureOld.adobeAnalyticsFeatures}`,
          feature_atual: `${featureNew.adobeAnalyticsFeatures}`,
          polegada_anterior: `${inchOld}`,
          polegada_atual: `${inchNew}`,
          preco_anterior: `${priceOld}`,
          preco_atual: `${priceNew}`,
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });


      // console.log('room old: ', roomOld.name);
      // console.log('room new: ', roomNew.name);

      // console.log('passion old: ', passionOld.adobeAnalyticsPassions);
      // console.log('passion new: ', passionNew.adobeAnalyticsPassions);

      // console.log('feature old: ', featureOld.adobeAnalyticsFeatures);
      // console.log('feature new: ', featureNew.adobeAnalyticsFeatures);

      // console.log('feature old: ', inchOld);
      // console.log('polegada new: ', inchNew);

      // console.log('preco old: ', priceOld);
      // console.log('preco new: ', priceNew);


      // Fim Môre Analytics

      if(this.finalFilterUserChoices.passionSelected !== 'todos' && !this.finalFilterUserChoices.featureSelected){
        Vue.$toast.open({
          message: 'Informe todas as preferências antes de prosseguir',
          type: 'error',
          position: 'bottom-right'
        });
      }else{
        let filter = {
          passion: this.finalFilterUserChoices.passionSelected,
          feature: this.finalFilterUserChoices.featureSelected,
          price: {
            min: this.minPrice,
            max: this.finalFilterUserChoices.priceSelected.maxPrice,
          },
        };

        let sizes = this.finalFilterUserChoices.inchSelected ? 
          this.finalFilterUserChoices.inchSelected.map((v) => v.replace('”', '')) :
          null;

        if(sizes !== null) Object.assign(filter, {
          sizes
        });

        this.$emit("handleUserChoices", 
        {
          filter,
          choices: {
            ...this.finalFilterUserChoices
          },
          finalFilter: true,
        });
        
        setTimeout(() => {
          document.getElementById("products-table").scrollIntoView({
            behavior: "smooth",
          });
        }, 500)
      }
    },
    handleOpenFinalFilters(){
      this.$emit("handleFinalFiltersIsOpen");
    },
    handleOpenDropdown(keyDropdown){
      if(keyDropdown === this.openDropdown){
        this.openDropdown = '';
      }else{
        this.openDropdown = keyDropdown;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../sass/main.scss";

.final-filters {
  display: flex;
  flex-direction: column;

  align-items: center;

  width: 100%;
  background-color: $color-gray;

  border-bottom: 1px solid $color-gray-extra-dark;

  .header-final-filter {
    display: flex;
    justify-content: space-between;
    width: 100%;

    padding: 1.5rem;

    h4 {
      font-family: $font-family-title;
      font-size: 1.5rem;
    }

    button{
      .openFinalFilters{
        transform: rotate(180deg);
      }
    }
  }

  .noPaddingBottomHeader{
    padding: 1.5rem 1.5rem 0 1.5rem;
  }

  .body-final-filters {
    display: none;

    flex-direction: column;
    align-items: center;

    width: 100%;

    .line-filters {
      display: flex;
      flex-direction: column;
      align-items: center;

      width: 100%;

      .filter {
        display: flex;
        align-items: center;
        flex-direction: column;

        width: 100%;

        .title-filter {
          display: flex;
          justify-content: flex-start;

          width: 80%;

          border-bottom: 1px solid $color-gray-extra-dark;
          margin: 2rem 3rem 0 3rem;

          p {
            font-family: $font-family-default-bold;
            font-size: 1.2rem;
            color: $color-gray-extra-dark;
          }
        }

        .preferences {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
        }
      }
    }

    .button-area{
      margin: 2rem 0;

      button{
        width: 127px;

        font-family: $font-family-default-bold;
        font-size: 1rem;
      }
    }

    :nth-child(2) > :nth-child(2) {
      .title-filter {
        padding-top: 4rem;
      }
    }
  }

  .openFinalFilters{
    display: flex;
  }
}

@media (min-width: 768px) {
  .final-filters {
    max-width: 1311px;
    margin: 0 2rem;

    .body-final-filters {
      flex-direction: column;
      justify-content: flex-start;

      .line-filters {
        flex-direction: row;
        justify-content: flex-end;

        .filter {
          align-items: flex-start;
          padding-left: 1.5rem;

          .title-filter {
            width: 90%;
            margin: 2rem 3rem 0 1.5rem;
          }

          .largest-title-filter {
            width: 90%;
          }

          .preferences {
            flex-direction: row;
            gap: 1.5rem;
          }
        }

        .filter-preferences, .price-filter{
          padding-right: 1.5rem;
        }

        .small-line-in-desktop{
          width: 60.5%;

          .title-filter{
            width: 65%;
          }
        }
      }

      .button-area{
        display: flex;
        justify-content: flex-start;

        padding-left: 1.5rem;

        width: 100%;
      }

      :nth-child(2) > :nth-child(2) {
        .title-filter {
          padding-top: 2rem;
        }
      }
    }
  }
}
</style>